export default {
  currency: "Currency",
  addCurrency: "AddCurrency",
  editCurrency: "EditCurrency",
};
